import { useEffect, useState } from "react";
import { api, rp } from "@/api";
import { StatCard } from "@/components/ReportPanel";

export function SummaryPanel({ refreshKey, onManage, range }) {
  const [sum, setSum] = useState(null);

  useEffect(() => {
    const params = range?.date_from ? { date_from: range.date_from, date_to: range.date_to } : {};
    api.get("/admin/summary", { params }).then((r) => setSum(r.data));
  }, [refreshKey, range?.date_from, range?.date_to]);

  if (!sum) return <p className="empty-note">Memuat...</p>;

  return (
    <div data-testid="summary-panel">
      <div className="stat-grid">
        <StatCard label="Jumlah Toko" value={sum.store_count} testId="summary-stores" />
        <StatCard label="Total Pesanan" value={sum.order_count} testId="summary-orders" />
        <StatCard label="Total Pembelian (Harga Beli)" value={rp(sum.revenue)} testId="summary-revenue" />
        <StatCard label="Total Selisih Jual − Beli" value={rp(sum.profit)} testId="summary-profit" accent="accent" />
        <StatCard label="Total Belum Bayar" value={rp(sum.unpaid_total)} testId="summary-unpaid" accent="warn" />
      </div>

      <h3 className="section-title">Per Toko</h3>
      <table className="report-table" data-testid="summary-table">
        <thead>
          <tr><th>Toko</th><th>Admin</th><th>Pesanan</th><th>Pembelian</th><th>Belum Bayar</th><th>Selisih</th><th /></tr>
        </thead>
        <tbody>
          {sum.stores.map((s) => (
            <tr key={s.store.id} data-testid={`summary-row-${s.store.slug}`}>
              <td><strong>{s.store.store_name}</strong><div className="muted-sm">/toko/{s.store.slug}</div></td>
              <td>{s.admin_username || "-"}</td>
              <td>{s.order_count}</td>
              <td>{rp(s.revenue)}</td>
              <td className="warn-text" data-testid={`summary-unpaid-${s.store.slug}`}>{rp(s.unpaid_total)}</td>
              <td className="profit-text">{rp(s.profit)}</td>
              <td><button className="btn-ghost sm" onClick={() => onManage(s.store)} data-testid={`summary-manage-${s.store.slug}`}>Kelola</button></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
